var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "who-has-access" },
    [
      _c("span", {
        staticClass: "icon icon-loading",
        class: { hidden: !_vm.isLoading }
      }),
      _vm._v(" "),
      _vm._l(_vm.admins, function(admin) {
        return _c(
          "div",
          { key: admin.id, staticClass: "admin-avatar-container" },
          [
            _c("avatar", {
              attrs: {
                user: admin.internal ? admin.id : null,
                "display-name": admin.displayname,
                size: 64,
                "is-no-user": !admin.internal
              }
            }),
            _vm._v(" "),
            !admin.internal
              ? _c("span", {
                  staticClass: "icon icon-close",
                  on: {
                    click: function($event) {
                      return _vm.deleteAdditionalAdmin(admin)
                    }
                  }
                })
              : _vm._e()
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.isAdmin
        ? _c("div", [
            !_vm.isAdding
              ? _c(
                  "div",
                  {
                    staticClass: "addAdditionalAdmin",
                    attrs: { title: _vm.additionalAdminPlaceholderLabel },
                    on: { click: _vm.openNewAdmin }
                  },
                  [_vm._v("\n\t\t\t+\n\t\t")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isAdding
              ? _c(
                  "form",
                  {
                    directives: [
                      {
                        name: "click-outside",
                        rawName: "v-click-outside",
                        value: _vm.closeNewAdmin,
                        expression: "closeNewAdmin"
                      }
                    ],
                    staticClass: "addAdditionalAdminFormContainer",
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.addAdditionalAdmin($event)
                      }
                    }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newAdditionalAdminInputField,
                          expression: "newAdditionalAdminInputField"
                        }
                      ],
                      attrs: {
                        type: "text",
                        maxlength: "64",
                        autocomplete: "new-password",
                        autocorrect: "off",
                        autocapitalize: "off",
                        spellcheck: "false",
                        placeholder: _vm.additionalAdminPlaceholderLabel
                      },
                      domProps: { value: _vm.newAdditionalAdminInputField },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.newAdditionalAdminInputField = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "icon-confirm",
                      attrs: { type: "submit", value: "" }
                    })
                  ]
                )
              : _vm._e()
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }